{ Analytics }  = require '@trello/atlassian-analytics'
Controller = require 'app/scripts/controller'
DirectoryPluginItemView = require 'app/scripts/views/directory/directory-plugin-item-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
PopOver = require 'app/scripts/views/lib/pop-over'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_power_up_slot')
{ trackUe } = require '@trello/analytics'

powerUpSlot = t.renderable ({ id, name, icon }) ->
  t.a '.board-menu-navigation-item-link.mod-enabled', { href: '#' }, ->
    t.span '.board-menu-navigation-item-link-icon.mod-enabled', style: "background-image: url(#{icon.url})"
    t.raw '&nbsp;'
    t.text name

module.exports = class BoardSidebarPowerUpSlotView extends DirectoryPluginItemView
  tagName: 'li'
  className: 'board-menu-navigation-item mod-power-up-slot'

  initialize: ({ @plugin }) ->
    super

  showListingOption: -> true

  events:
    'click': 'toggleOptions'

  navigateToListing: ->
    directoryListingUrl = Controller.getBoardUrl(@model.id, 'power-up', [@plugin.id])
    Controller.navigate directoryListingUrl, { trigger: true }
    PopOver.hide()
    trackUe('power-up slot', 'opens', 'Power-Up directory list page', '', '', 'by clicking view Power-Up', @plugin.id)
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'powerUpSlotButton'
        source: 'boardMenuDrawerDefaultScreen'
        containers:
          board:
            id: @model.id
        attributes:
          powerUpId: @plugin.id

  render: ->
    @$el.html powerUpSlot({
      id: @plugin.id
      name: @plugin.get('name')
      icon: @plugin.get('icon')
    })

    @
